import { lazy } from "react";

const adminRoutes = [
  {
    path: "/admin/dashboard",
    component: lazy(() => import("../Pages/Admin/Dashboard/Index")),
    isPublic: false,
    exact: true,
  },
  {
    path: "/admin/shelter",
    component: lazy(() => import("../Pages/Admin/Shelter/index")),
    isPublic: false,
    exact: true,
  },
  {
    path: "/admin/archived-shelters",
    component: lazy(() => import("../Pages/Admin/Shelter/ArchivedShelters")),
    isPublic: false,
    exact: true,
  },
  {
    path: "/admin/shelter/adopters/:id",
    component: lazy(() => import("../Pages/Admin/Abopters/index")),
    isPublic: false,
    exact: true,
  },
  {
    path: "/admin/settings",
    component: lazy(() => import("../Pages/Admin/Package_Limits/index")),
    isPublic: false,
    exact: true,
  },
  {
    path: "/admin/pendingShelters",
    component: lazy(() => import("../Pages/Admin/PendingShelters/index")),
    isPublic: false,
    exact: true,
  },
  {
    path: "/admin/orderHistory/",
    component: lazy(() => import("../Pages/Admin/Order_History/index")),
    isPublic: false,
    exact: true,
  },
  {
    path: "/admin/orderHistory/:id",
    component: lazy(() => import("../Pages/Admin/Order_History/index")),
    isPublic: false,
    exact: true,
  },
  {
    path: "/admin/manageSubscription/:id",
    component: lazy(() => import("../Pages/Admin/Manage_Subscription/index")),
    isPublic: false,
    exact: true,
  },
  {
    path: "/admin/repeatAdopters",
    component: lazy(() => import("../Pages/Admin/Repeat_Adopters/index")),
    isPublic: false,
    exact: true,
  },
];

export default adminRoutes;
